import StartupsCaptablesInstance from 'modules/startupsCaptables/repository';

export function getStartupCaptables(id, opts) {
  return StartupsCaptablesInstance.getStartupCaptables(id, opts);
}
